import authFetch from './fetch';
import { makeRequest } from './utils';

const routes = {
  signalRTokenRoute: () => '/api/me/signalRToken',
};

// Configure the token refresh interval in minutes:
const REFRESH_INTERVAL_MINUTES = 10;
const STORAGE_KEY = 'signalRToken';

export const getSignalRToken = async () => {
  try {
    const storedData = sessionStorage.getItem(STORAGE_KEY);
    if (storedData && storedData !== 'undefined') {
      const { token, timestamp } = JSON.parse(storedData);
      const now = Date.now();
      const intervalInMs = REFRESH_INTERVAL_MINUTES * 60 * 1000;
      // If token is still fresh, return it:
      if (now - timestamp < intervalInMs) {
        return token;
      }
    }

    // Otherwise, fetch a new token:
    const token = await makeRequest(authFetch.get(routes.signalRTokenRoute()));
    if (token) {
      sessionStorage.setItem(STORAGE_KEY, JSON.stringify({ token, timestamp: Date.now() }));
    }
    return token;
  } catch (error) {
    console.error('Error fetching SignalR token:', error);
    throw error;
  }
};
